export default __webpack_public_path__ + "static/media/640_dummy2016-personal01-mobile-de.bc9f9129.png";